document.addEventListener('DOMContentLoaded', () => {
  const containers = document.querySelectorAll('.section-homepage-hero__logotypes');
  if (!containers.length) return;

  const PRM = window.matchMedia('(prefers-reduced-motion: reduce)');
  const INTERVAL = 3.5;  // seconds between page switches
  const OUT_DUR  = 0.25; // fade-out duration
  const IN_DUR   = 0.35; // fade-in duration

  containers.forEach(setup);

  function setup(container) {
    const items = Array.from(container.querySelectorAll('.section-homepage-hero__logotypes__item'));
    if (!items.length) return;

    let cols = readCols(container);
    let pageIndex = 0;
    let pages = chunk(items, cols);
    let auto;

    applyPage(0, true);

    if (!PRM.matches && pages.length > 1) schedule();

    container.addEventListener('mouseenter', pause);
    container.addEventListener('mouseleave', resume);
    container.addEventListener('focusin', pause);
    container.addEventListener('focusout', resume);

    let rAF;
    window.addEventListener('resize', () => {
      cancelAnimationFrame(rAF);
      rAF = requestAnimationFrame(() => {
        const newCols = readCols(container);
        if (newCols !== cols) {
          cols = newCols;
          pages = chunk(items, cols);
          pageIndex = 0;
          applyPage(0, true);
          if (!PRM.matches && pages.length > 1) schedule();
          else cancel();
        }
      });
    });

    PRM.addEventListener?.('change', () => {
      if (PRM.matches) {
        cancel();
        applyPage(0, true);
      } else {
        if (pages.length > 1) schedule();
      }
    });

    function readCols(el) {
      const v = getComputedStyle(el).getPropertyValue('--logos-cols').trim();
      const n = parseInt(v, 10);
      return Number.isFinite(n) && n > 0 ? n : 5;
    }

    function chunk(arr, size) {
      if (size <= 0) return [arr.slice()];
      const out = [];
      for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
      return out;
    }

    function applyPage(index, immediate = false) {
      const toShow = new Set(pages[index] || []);
      const toHide = items.filter(el => !toShow.has(el));

      // if there’s only one page or immediate initial render
      if (immediate || pages.length <= 1) {
        items.forEach(el => {
          if (toShow.has(el)) {
            el.classList.remove('is-hidden');
            el.style.opacity = '';
          } else {
            el.classList.add('is-hidden');
            el.style.opacity = '';
          }
        });
        return;
      }

      // fade current visible out, then fade next page in
      const currentlyVisible = items.filter(el => !el.classList.contains('is-hidden'));

      const tl = gsap.timeline();
      tl.to(currentlyVisible, {
        opacity: 0,
        duration: OUT_DUR,
        stagger: 0.02,
        onComplete: () => {
          // hide all, show next
          items.forEach(el => el.classList.add('is-hidden'));
          toShow.forEach(el => {
            el.classList.remove('is-hidden');
            el.style.opacity = 0;
          });
        }
      });
      tl.to(Array.from(toShow), {
        opacity: 1,
        duration: IN_DUR,
        stagger: 0.03,
        clearProps: 'opacity'
      }, '+=0.02');
    }

    function nextPage() {
      pageIndex = (pageIndex + 1) % pages.length;
      applyPage(pageIndex);
      schedule();
    }

    function schedule() {
      cancel();
      auto = gsap.delayedCall(INTERVAL, nextPage);
    }

    function cancel() {
      if (auto) { auto.kill(); auto = null; }
    }

    function pause() {
      if (auto) auto.pause();
    }
    function resume() {
      if (PRM.matches) return;
      if (auto) auto.play();
    }
  }
});
